import { useLocation, useNavigate } from "react-router-dom";

export const WithRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    
    // Just pass the navigation props without forcing a redirect
    return <Component navigate={navigate} location={location} {...props} />;
  };

  return Wrapper;
};
